import React from 'react';
import { ClickableItem, Flex, Icon, Input } from '@upsales/components';
import type { EditWidgetRowProps, WidgetClickProps } from 'App/components/hooks/integrations/externalIntegrationTypes';
import ClickSetting from './helpers/ClickSetting';
import WidgetFieldSetting from './helpers/WidgetFieldSetting';
import { useTranslation } from 'Components/Helpers/translate';

export const EditUiWidgetDropdownOption: React.FC<EditWidgetRowProps> = ({ row, onUpdate }) => {
	const { t } = useTranslation();

	const handleClickSettingChange = (clickAction: string, clickSettings: Record<string, any>) => {
		const updatedOption = {
			...row,
			settings: {
				...row.settings,
				click: clickAction,
				clickSettings
			}
		};
		onUpdate(updatedOption);
	};

	const handleChange = (field: string, value: string) => {
		const updatedOption = {
			...row,
			settings: {
				...row.settings,
				[field]: value
			}
		};
		onUpdate(updatedOption);
	};

	return (
		<Flex gap="u2" direction="column" className="EditUiWidgetDropdownOption">
			<WidgetFieldSetting text={t('default.text')}>
				<Input value={row.settings?.text} onChange={e => handleChange('text', e.target.value)} />
			</WidgetFieldSetting>

			<WidgetFieldSetting text={t('default.subtitle')}>
				<Input value={row.settings?.subtitle} onChange={e => handleChange('subtitle', e.target.value)} />
			</WidgetFieldSetting>

			<WidgetFieldSetting text={t('default.icon')}>
				<Flex gap="u3" alignItems="center">
					<Input value={row.settings?.icon} onChange={e => handleChange('icon', e.target.value)} />
					<Icon name={row.settings?.icon} />
				</Flex>
			</WidgetFieldSetting>

			<ClickSetting
				row={row}
				onChange={(clickAction, clickSettings) => handleClickSettingChange(clickAction, clickSettings)}
			/>
		</Flex>
	);
};

export const UiWidgetDropdownOption: React.FC<WidgetClickProps> = ({ row, onClick }) => {
	const title = row.settings?.text;
	const subtitle = row.settings?.subtitle;
	const icon = row.settings?.icon;
	const click = row.settings?.click;
	const clickSettings = row.settings?.clickSettings;

	const handleClick = () => {
		onClick?.(click, clickSettings);
	};

	return <ClickableItem icon={icon} title={title} subtitle={subtitle} onClick={handleClick} />;
};
